import type {SocialAccount} from '@Components/social-media/account.vo';

export const FACEBOOK_REEL_ACTION_ICONS: string[] = ['icon-thumbs-up', 'icon-comment', 'icon-share-external', 'icon-bookmark', 'icon-more-h'];

export interface FacebookOverlayProps {
  account: SocialAccount;
  caption: string;
}
